const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getVisaHistoryUrl = (applicationId, role) => {
  switch (role) {
    case 'super_admin':
      return `${API_URL}/super-admin/visa-applications/${applicationId}/status-history`;
    case 'manager':
      return `${API_URL}/manager/visa-applications/${applicationId}/status-history`;
    case 'company_admin':
      return `${API_URL}/visa-applications/${applicationId}/status-history`;
    case 'company_manager':
      return `${API_URL}/company-manager/visa-applications/${applicationId}/status-history`;
    case 'company_employee':
      return `${API_URL}/company-employee/visa-applications/${applicationId}/status-history`;
    default:
      return null;
  }
};

export const getVisaFormLabelsUrl = (applicationId) =>
  `${API_URL}/meta/visa-applications/${applicationId}/form-labels`;

export const getVisaFormParamsUrl = (applicationId) =>
  `${API_URL}/meta/visa-applications/${applicationId}/form-params`;

/** Shared form fill/update endpoint for company admin, manager, and employee. */
export const getVisaFormUpdateUrl = (applicationId) =>
  `${API_URL}/visa-applications/${applicationId}/form`;

export const formatHistoryDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
